import { OrderStoreState } from "../stores/order.store";
import { Address } from "./address.types";
import { SavedFile } from "./files.types";
import { ActivityLog } from "./logs.types";
import { Patient } from "./patient.types";
import { PurchaseOrder } from "./purchase_orders.types";

export enum CommandStatus {
  DRAFT = "DRAFT",
  WAITING_FOR_RECEPTION = "WAITING_FOR_RECEPTION",
  RECEIVED = "RECEIVED",
  MODELING = "MODELING",
  PRINTING = "PRINTING",
  INJECTING = "INJECTING",
  POLISHING = "POLISHING",
  QUALITY_CONTROL = "QUALITY_CONTROL",
  READY_FOR_DELIVERY = "READY_FOR_DELIVERY",
  IN_DELIVERY = "IN_DELIVERY",
  ABORTED = "ABORTED",
  PENDING = "PENDING",
  DELIVERED = "DELIVERED",
}

export enum CommandType {
  THREED = "THREED",
  OTOSCAN = "OTOSCAN",
  POSTE = "POSTE",
  REWORK = "REWORK",
  SUPPLY = "SUPPLY",
}

export type Command = {
  id: number;
  exposedId: string;
  createdAt: Date;
  updatedAt: Date;
  deliveredAt: Date | null;
  patientId: number; // patient
  patient?: Patient; // patient
  status: CommandStatus;
  type: CommandType;
  creatorId: number; // user
  creator: {
    firstName: string;
    lastName: string;
  };
  externalId?: string;
  centerId: number; // center
  center: {
    name?: string;
    phoneNumber?: string;
    enterprise?: {
      name?: string;
    };
  };
  haltedAt: Date;
  haltedReason: string;
  haltedExplanation: string;
  billingAddressId: number | null;
  billingAddress?: Address;
  shippingAddressId: number | null;
  shippingAddress?: Address;
  company?: string;
  activityLogs: ActivityLog[];
  managerId: number; // user
  draft?: OrderStoreState;
  purchaseOrderFileId: number | null;
  purchaseOrderFile?: SavedFile;
  purchaseOrderId: number | null;
  purchaseOrder?: PurchaseOrder;
  discount: number | null;
  conformityNoteFileId: number | null;
  conformityNoteFile?: SavedFile;
  informationSheetFileId: number | null;
  informationSheetFile?: SavedFile;
  labelFileId: number | null;
  labelFile?: SavedFile;
};

export type CommandTracking = {
  datetime: string;
  location: {
    slic?: string;
    address?: {
      countryCode?: string;
      country?: string;
      city?: string;
    };
  };
  status: {
    type?: string;
    description?: string;
    code?: string;
    statusCode?: string;
  };
};
